<template>
  <Content @back="$router.push('/home')">
    <!-- 专家评估用 -->
    <template v-slot:nav_left>
      <div class="nav-btn-box">
        <p>评估考核列表</p>
      </div>
    </template>
    <template v-slot:nav_right>
      <template>

      </template>
    </template>

    <template v-slot:content_right>
      <div class="com-wrapper content-inner-wrapper">
        <div class="select_wrap">
          <div class="select_box left"></div>
          <div class="select_box right">
            <input
              type="text"
              v-model="selectVal.stageName"
              class="yioks_input"
              style="width: 160px"
              placeholder="请输入关键字"
              @keyup.enter="changeQuery(true)"
            />
            <div class="yioks_btn" @click="changeQuery(true)">搜索</div>
          </div>
        </div>
        <div class="list_wrap" v-if="!loading && pageList.length">
          <div class="table">
            <div class="thead">
              <div class="tr">
                <div class="th seq">序号</div>
                <div class="th stageName" :class="{ big: !isInClubSystem }">申报评估考核阶段名称</div>
                <div class="th jixiaoType">评估对象</div>
                <div class="th description">评估简介</div>
                <div class="th start-time">开始时间</div>
                <div class="th end-time">结束时间</div>
                <div class="th stageStartDate">已/未提交</div>
                <template v-if="isInClubSystem">
                  <div class="th stageEndDate">已/未评估</div>
                </template>
                <div class="th action">操作</div>
              </div>
            </div>
            <div class="scrollArea">
              <vue-scroll>
                <div class="tbodyWrap">
                  <div class="tbody">
                    <div
                      class="tr"
                      v-for="(item, index) in pageList"
                      :key="index"
                    >
                      <div class="td seq">
                        <p>{{ index + 1 }}</p>
                      </div>
                      <div class="td stageName" :class="{ big: !isInClubSystem }">
                        <p :title="item.stageName">{{ item.stageName }}</p>
                      </div>
                      <div class="td jixiaoType">
                        <p :title="item.jixiaoType | performanceTypeFilter">
                          {{ item.jixiaoType | performanceTypeFilter }}
                        </p>
                      </div>
                      <div class="td description">
                        <p :title="item.description">{{ item.description }}</p>
                      </div>

                      <div class="td start-time">
                        <p>{{ item.stageStartDate | time(false) }}</p>
                      </div>
                      <div class="td end-time">
                        <p>{{ item.stageEndDate | time(false) }}</p>
                      </div>
                      <div class="td stageStartDate">
                        <p>
                          {{ item.submitNum }}&nbsp;/&nbsp;{{
                            item.noSubmitNum
                          }}
                        </p>
                      </div>
                      <template v-if="isInClubSystem">
                        <div class="td stageEndDate">
                          <p>
                            {{ item.auditNum }}&nbsp;/&nbsp;{{ item.noAuditNum }}
                          </p>
                        </div>
                      </template>
                      <div class="td action">
                        <p>
                          <span class="item" @click="handleCheckRow(item)"  v-if="isInClubSystem">开始评估</span>
                          <span class="item" @click="handleCheckRow(item)"  v-else>查看</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </vue-scroll>
            </div>
          </div>
        </div>
        <yioks-loading v-if="loading" />
        <yioks-empty
          v-if="!loading && !pageList.length"
          tips="暂时没有数据"
        ></yioks-empty>
      </div>
      <Pagination :total="total" :page.sync="page" />
    </template>
  </Content>
</template>

<script>
import storage from "@/utils/storage";
import { performanceTypeFilter } from "@/assets/js/yioksFilters";
import { getExpertAuditStagePage } from "@/api/export/index";
import mixinAppConfig from "@/mixin/mixinAppConfig";

export default {
  mixins: [mixinAppConfig],
  components: {
    Content: () => import("@/components/layout/list"),
    Pagination: () => import("@/components/Pagination"),
  },

  data() {
    return {
      userRole: storage.get("userInfo").userRole,
      total: 0,
      page: 0,
      pageSize: 20,
      loading: false,
      empty: false,
      selectVal: {
        stageName: "",
      },
      pageList: [],
    };
  },

  filters: {
    performanceTypeFilter,
  },

  created() {
    this.loadPageList();
  },

  methods: {

    changeQuery(flag) {
      flag && (this.page = 0);
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          ...this.selectVal,
          page: this.page,
          size: this.pageSize,
        },
      });
      this.loadPageList();
    },

    loadPageList() {
      const { page,stageName } = this.$route.query;
      page && (this.page = Number(page));
      stageName && this.$set(this.selectVal, "stageName", stageName);

      const paramsData = {
        page: page || 0,
        size: this.pageSize,
        ...this.selectVal,
      };
      this.loading = true;
      getExpertAuditStagePage(paramsData)
        .then((res) => {
          this.loading = false;
          if (res.code) {
            this.$message.error(res.msg);
            return;
          }
          const { content, totalElements } = res;
          this.total = totalElements;
          this.pageList = content;
        })
        .catch((err) => {
          this.loading = false;
          console.error("err", err);
        });
    },

    // 操作
    handleCheckRow(row) {
      const { groupUuid, open, uuid: stageUuid, jixiaoType } = row;
      this.$router.push({
        path: "unAuditYouthList",
        query: {
          groupUuid: groupUuid,
          stageUuid: stageUuid,
          canEdit: open ? 1 : 2,
        },
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.nav-btn-box
  display flex
  .btn
    margin-right 20px
    padding 10px 15px
    cursor pointer
    user-select none
    &.active
      background-color $green_color
</style>


<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.content-inner-wrapper
  height 560px
.list_wrap
  flex 1
  overflow hidden
  .table
    display flex
    flex-direction column
    flex 1
    width 100%
    // margin: 30px 0 0;
    .thead, .tbody
      border 1px solid $color_white
    .thead
      margin 0 40px
      .tr
        min-height 45px
        height auto
        display flex
    .scrollArea
      height 425px
      padding-bottom 15px
      /* flex 1 */
      /* overflow hidden */
    .tbodyWrap
      display block
      // padding: 0 40px;
    .tbody
      display block
      width 810px
      margin-left auto
      margin-right auto
      max-width 810px
      border-top none
      border-bottom none
      .tr
        min-height 49px
        height auto
        display flex
        border-bottom 1px solid $color_white
    .th, .td
      height inherit
      /* flex: 1 1 auto; */
      display flex
      justify-content center
      align-items center
      font-size $font_size_medium
      border-right 1px solid $color_white
    .th:last-child, .td:last-child
      border-right none
    .td
      p
        // white-space nowrap
        // overflow hidden
        // text-overflow ellipsis
        padding 3px 0px
        text-align center
        line-height 1.4em
        color $color_white
        white-space pre-line
.seq
  width 5%
.stageName
  width 20%
  &.big
    width 25%
.jixiaoType
  width 9%
.description
  width 18%
.start-time
  width 11%
.end-time
  width 11%
.stageStartDate
  width 9%
.stageEndDate
  width 9%
.action
  // width 8%
  flex 1
  .item
    cursor pointer
    user-select none
    color $green_color
  .split
    margin 0 5px
</style>

<style lang="stylus" >
.y-input
  input
    border-radius 0px !important
</style>
